export const proxyErrorStyle = (error, style) =>
  (error && `error ${style}`) || ((style && style) || null);
